export let countryCodesByAlpha3: {
  [key: string]: { name: string; alpha2: string };
} = require("./country-codes-by-alpha3.json");


const countryCodeValues = Object.keys(countryCodesByAlpha3).map((key) => ({
  key: key,
  name: countryCodesByAlpha3[key].name,
  alpha2: countryCodesByAlpha3[key].alpha2,
}));

countryCodesByAlpha3 = countryCodeValues
  .sort((a, b) => a.name.localeCompare(b.name))
  .reduce(
    (acc, cur) => ({
      ...acc,
      [cur.key]: { name: cur.name, alpha2: cur.alpha2 },
    }),
    {}
  );
